import { apiFetch } from "../lib/api";

/** One executed order, as it appears on a contract note. */
export interface TradeLeg {
  side: "BUY" | "SELL";
  quantity: string;
  price: string;
}

export interface LegCharge {
  side: string;
  quantity: string;
  price: string;
  turnover: string;
  charges: Record<string, string>;
}

export interface ChargePreview {
  segment: string;
  rates_verified_on: string;
  legs: LegCharge[];
  totals: Record<string, string>;
  note: string;
}

export interface ChargeSchedule {
  rates_verified_on: string;
  brokers: Record<string, Record<string, Record<string, string>>>;
}

export async function getChargeSchedule(): Promise<ChargeSchedule> {
  return apiFetch<ChargeSchedule>("/charges/schedule");
}

/** Compute charges for a set of legs so they can be compared, line by line,
 *  against a real contract note. Published rates go stale — on 2026-08-19
 *  Upstox's own page still showed the pre-April options STT — so the bill is
 *  the only trustworthy check. */
export async function previewCharges(payload: {
  broker: string;
  exchange: string;
  instrument_type: string;
  product?: string;
  legs: TradeLeg[];
  overrides?: Record<string, Record<string, string>>;
}): Promise<ChargePreview> {
  return apiFetch<ChargePreview>("/charges/preview", {
    method: "POST",
    body: payload,
  });
}
